import {Box, IconButton, InputAdornment, InputLabel, Stack, TextField, Tooltip, Typography} from '@mui/material';
import {
  Add as AddIcon,
  Remove as RemoveIcon, RestartAlt,
} from '@mui/icons-material';
import {useTheme} from '@mui/material/styles';
import {memo} from 'react';



const MhdInput = ({ label, value, override, warning, error, onChange, disabled, units, step='1.0', clear=false }) => {
  const theme = useTheme()

  const handleIncrement = () => {
    let newValue = parseFloat(override ?? value);

    if (isNaN(newValue)) {
      newValue = 0;
    }

    newValue += parseFloat(step);
    onChange(String(newValue))
  };

  const handleDecrement = () => {
    let newValue = parseFloat(override ?? value);

    if (isNaN(newValue)) {
      newValue = 0;
    }

    newValue -= parseFloat(step);
    onChange(String(newValue))
  }
  return (
    <>
      <InputLabel variant={error ? 'error' : 'primary'}>
        {label}
      </InputLabel>
      <Tooltip
        title={warning} arrow
        componentsProps={{
          tooltip: {sx: {backgroundColor: theme.palette.error.main, color: 'white'}},
          arrow: {sx: {color: theme.palette.error.main}},
        }}
      >
        <Box sx={{ position: 'relative', display: 'inline-block', width: '100%'}}>
          <TextField
            type='text'
            fullWidth
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value)}
            error={error}
            disabled={disabled}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end' sx={{marginRight: -1}}>
                  {units && <Typography pr='4px'>{units}</Typography>}
                  <Stack direction='column' spacing='3px'>
                    <IconButton
                      onClick={handleIncrement}
                      disabled={disabled}
                      sx={{
                        padding: '5px',
                        height: 4,
                        width: 4,
                        backgroundColor: theme.palette.base.rothko5,
                        color: '#000000',
                        '&:hover': {
                          backgroundColor: theme.palette.base.rothko6,
                        },
                      }}
                    >
                      <AddIcon sx={{fontSize: '5px',}}/>
                    </IconButton>
                    <IconButton
                      onClick={handleDecrement}
                      disabled={disabled}
                      sx={{
                        padding: '5px',
                        height: 4,
                        width: 4,
                        backgroundColor: theme.palette.base.rothko5,
                        color: '#000000',
                        '&:hover': {
                          backgroundColor: theme.palette.base.rothko6,
                        },
                      }}
                    >
                      <RemoveIcon sx={{fontSize: '6px'}}/>
                    </IconButton>
                </Stack>
                </InputAdornment>
              ),
            }}
          />
          <IconButton
            onClick={() => onChange('')}
            color='primary'
            sx={{
              position: 'absolute',
              zIndex: 1,
              right: -8,
              top: -8,
              width: 8,
              height: 8,
            }}
          >
            <RestartAlt fontSize='small' />
          </IconButton>
        </Box>
      </Tooltip>
      {(override || override === 0) &&
        <Typography variant='caption' color='error'>
          Modified: {override.toExponential(2)} {units}
        </Typography>
      }
    </>
  );
};

export default memo(MhdInput);